export enum ContractApplicabilityFilter {
  APPLICABLE = 'applicable',
  INAPPLICABLE = 'inapplicable',
}

export enum BaseScale {
  DAY = 'day',
  MONTH = 'month',
}

export enum IncomeStatisticsFilterKeys {
  selectedWarehouses = 'selectedWarehouses',
  isApplicable = 'isApplicable',
  startDate = 'startDate',
  endDate = 'endDate',
  scale = 'scale',
}
